import React, { useState } from "react";
import { Layers, Plus, Presentation, Search } from "lucide-react";
import PresentationsList, { NewPresentationDialog } from "./PresentationsList";
import { AssemblyList, NewAssemblyDialog } from "./PresentationAssembly";

const FILTERS = [
  { value: "", label: "Toutes" },
  { value: "project", label: "Projets" },
  { value: "client", label: "Clients" },
  { value: "programme", label: "Programmes" },
];

// Outils → Présentations : les présentations client faites dans Deepflow, au format des propositions.
const PresentationsPage = () => {
  const [query, setQuery] = useState("");
  const [scopeType, setScopeType] = useState("");
  const [archived, setArchived] = useState(false);
  const [creating, setCreating] = useState(false);
  const [assembling, setAssembling] = useState(false);
  return (
    <div className="mx-auto max-w-4xl space-y-5 py-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="space-y-1">
          <h1 className="flex items-center gap-2 text-2xl font-semibold text-slate-900">
            <Presentation className="h-6 w-6 text-blue-600" /> Présentations
          </h1>
          <p className="text-sm text-slate-500">
            Présentations client au format des propositions, pour un projet, un client ou un programme. Le PDF est tenu à
            jour sur le Drive ; Nexus suit les consignes tirées de vos retours.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button type="button" onClick={() => setAssembling(true)}
            title="Réunir les présentations de plusieurs projets d'un client en une seule, chacune restant dans son projet"
            className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-800 hover:bg-slate-50">
            <Layers className="h-4 w-4" /> Point client
          </button>
          <button type="button" onClick={() => setCreating(true)}
            className="inline-flex items-center gap-1.5 rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-700">
            <Plus className="h-4 w-4" /> Nouvelle présentation
          </button>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <div className="relative min-w-[14rem] flex-1">
          <Search className="pointer-events-none absolute left-2 top-2.5 h-4 w-4 text-slate-400" />
          <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Titre, projet, client"
            className="w-full rounded-lg border border-slate-300 py-2 pl-8 pr-3 text-sm focus:border-blue-400 focus:outline-none" />
        </div>
        <div className="flex rounded-full border border-slate-200 bg-white p-0.5 text-sm">
          {FILTERS.map((item) => (
            <button key={item.value} type="button" onClick={() => setScopeType(item.value)}
              className={`rounded-full px-3 py-1 ${scopeType === item.value ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
              {item.label}
            </button>
          ))}
        </div>
        <label className="flex items-center gap-1.5 text-sm text-slate-600">
          <input type="checkbox" checked={archived} onChange={(event) => setArchived(event.target.checked)} /> Archivées
        </label>
      </div>
      {!query && !scopeType && <AssemblyList />}
      <div className="rounded-xl border border-slate-200 bg-white p-3 shadow-sm">
        <PresentationsList backLabel="Présentations" params={{ q: query, scope_type: scopeType, include_archived: archived || undefined, limit: 100 }}
          emptyText="Aucune présentation pour l'instant : « Nouvelle présentation », ou demandez-en une à Nexus." />
      </div>
      {assembling && <NewAssemblyDialog onClose={() => setAssembling(false)} />}
      {creating && <NewPresentationDialog backLabel="Présentations" onClose={() => setCreating(false)} />}
    </div>
  );
};

export default PresentationsPage;
